/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownLeftIcon24Regular = forwardRef('ArrowADownLeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6.112 19.125H16.5a.875.875 0 0 1 0 1.75H6A2.875 2.875 0 0 1 3.125 18V7.5a.875.875 0 1 1 1.75 0v10.388L18.881 3.88A.875.875 0 1 1 20.12 5.12L6.112 19.125Z" })));
});
